//@ts-ignore
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
const group = document.querySelectorAll(".lightbox");
group.forEach((element) => {
  const fancyboxElement = element.querySelector("[data-fancybox]");
  if (fancyboxElement) {
    const fancybox = fancyboxElement.getAttribute("data-fancybox"); 
    Fancybox.bind(`[data-fancybox=${fancybox}]`, {
    });
  };
});

